import React from 'react'
import { Col, Form, Input, Select } from 'antd'
import { get, isEmpty } from 'lodash'
import Switch, { Case, Default } from 'react-switch-case'
import {
  rules,
  threeFormItemLayout,
  defaultFormItemLayout,
  fullWidthFormItemLayout,
} from '../modules/FormItems'
import useFetchSelectUrl from './Hooks/useFetchSelectUrl'

const { TextArea } = Input

const columns = {
  3: {
    span: 8,
    layout: threeFormItemLayout,
  },
  2: {
    span: 12,
    layout: defaultFormItemLayout,
  },
  1: {
    span: 24,
    layout: fullWidthFormItemLayout,
  },
}

const CustomFormGenerated = props => {
  const { data, form, column = 2, label, path, type, rule = true, options = {} } = props

  console.log({
    data,
    form,
    column,
    label,
    path,
    type,
    rule,
    options,
  })
  const { getFieldDecorator } = form

  const col = columns[column]
  const fieldOptions = {
    initialValue: get(data, path),
    rules: rule && rules.input,
  }

  const {
    url,
    dependencyArray = [],
    doNotFetch = false,
    mapFunc = i => i,
    keyAtr = '_id',
    valueAtr = 'name',
  } = options

  const [SelectUrl] = useFetchSelectUrl(
    {
      name: label.toLowerCase(),
      url,
    },
    dependencyArray,
    isEmpty(options) && doNotFetch,
    Select,
    mapFunc,
  )

  return (
    <Col span={col.span}>
      <Form.Item {...col.layout} label={label}>
        <Switch condition={type}>
          <Case value="input">
            {getFieldDecorator(
              path,
              fieldOptions,
            )(<Input style={{ width: '100%' }} placeholder={label} />)}
          </Case>
          <Case value="text">
            {getFieldDecorator(
              path,
              fieldOptions,
            )(<TextArea autosize={true} placeholder={label} />)}
          </Case>
          <Case value="selectUrl">
            {getFieldDecorator(
              path,
              fieldOptions,
            )(<SelectUrl keyAtr={keyAtr} valueAtr={valueAtr} placeholder={label} />)}
          </Case>
          <Case value="Select">
            {getFieldDecorator(
              path,
              fieldOptions,
            )(
              <Select style={{ width: '100%' }}>
                {options.map(op => (
                  <Select.Option value={op}>{op}</Select.Option>
                ))}
              </Select>,
            )}
          </Case>
          <Default>
            {getFieldDecorator(
              path,
              fieldOptions,
            )(<Input style={{ width: '100%' }} placeholder={label} />)}
          </Default>
        </Switch>
      </Form.Item>
    </Col>
  )
}

export default CustomFormGenerated
